<template>
  <div class="popup">
    <h1 style="color: #ffddac; font-weight: bold; font-size: 0.38rem">
      {{ title.toUpperCase() }}
    </h1>
    <div class="steps">
      <div class="step">
        <div class="step-head">
          <div :class="`icon ${parseInt(verifkStep) >= 1 ? 'active-icon' : ''}`">1</div>
          <div :class="`line ${parseInt(verifkStep) > 1 ? '' : 'active-line'}`"></div>
        </div>
      </div>
      <div class="step">
        <div class="step-head">
          <div :class="`icon ${parseInt(verifkStep) >= 2 ? 'active-icon' : ''}`">2</div>
          <div :class="`line ${parseInt(verifkStep) > 2 ? '' : 'active-line'}`"></div>
        </div>
      </div>
      <div class="step">
        <div class="step-head">
          <div :class="`icon ${parseInt(verifkStep) >= 3 ? 'active-icon' : ''}`">3</div>
        </div>
      </div>
    </div>
    <h1 v-if="verifkStep == 1" style="color: #ffddac; margin-bottom: 1.5rem">
      {{ $t('verify.enterphone') }}
    </h1>
    <h1 v-if="verifkStep == 2" style="color: #ffddac">
      {{ $t('verify.vercode') }}
    </h1>
    <h1 v-if="verifkStep == 3" style="color: #ffddac">
      {{ $t('verify.newpassword') }}
    </h1>
    <van-form v-if="verifkStep == 1" class="flex column center">
      <InputField
        v-model="username"
        :placeholder="$t('register.username-tip')"
        :validate="validateUsername"
        style="margin-bottom: 0.2rem; font-size: 0.28rem"
        :isPhone="true"
        :from="from"
        :maxlength="10"
        inputType="reset_username"
        :key="userNameKey"
        :focus="usernameFocus"
        :enter="
          () => {
            usernameFocus = false
            onNext()
          }
        "
        type="number"
      />
    </van-form>
    <h2 v-if="verifkStep == 2" style="font-size: 0.28rem; margin-top: 0.6rem">
      {{ $t('verify.hassend') }}
    </h2>
    <h2
      v-if="verifkStep == 2"
      style="margin-top: 0.2rem; margin-bottom: 0.35rem; font-size: 0.32rem"
    >
      +{{ countries[country].phone }}{{ username }}
    </h2>
    <form v-show="verifkStep == 2" style="margin-bottom: 0.3rem" :key="codeKey" autocomplete="off">
      <div class="code_digit">
        <li>{{ code[0] ? code[0] : '' }}</li>
        <li>{{ code[1] ? code[1] : '' }}</li>
        <li>{{ code[2] ? code[2] : '' }}</li>
        <li>{{ code[3] ? code[3] : '' }}</li>
        <li>{{ code[4] ? code[4] : '' }}</li>
        <li>{{ code[5] ? code[5] : '' }}</li>
        <input
          id="code"
          name="code"
          class="code"
          type="text"
          maxlength="6"
          v-model="code"
          @input="onChangeCode"
          autocomplete="off"
        />
      </div>
    </form>
    <p
      v-if="verifkStep == 2 && cd > 0"
      style="text-align: center; font-size: 0.31rem; margin-bottom: 0.5rem; margin-top: 0.2rem"
    >
      {{ $t('verify.cd', { value: cd }) }}
    </p>
    <p
      @click="onTryAgain"
      v-if="verifkStep == 2 && cd <= 0"
      style="
        text-align: center;
        text-decoration-line: underline;
        font-size: 0.31rem;
        margin-bottom: 0.5rem;
        margin-top: 0.2rem;
        color: #ffddac;
      "
    >
      {{ $t('message.tryAgain') }}
    </p>
    <van-form
      v-show="verifkStep == 3"
      class="flex column center"
      style="margin-top: 1.5rem; margin-bottom: 0.1rem"
    >
      <InputField
        v-model="password"
        :placeholder="$t('register.password-tip')"
        :validate="validatePassword"
        type="password"
        style="margin-bottom: 0.1rem; font-size: 0.28rem"
        :from="from"
        inputType="reset_password"
        :key="passwordKey"
        :focus="passwordFocus"
        :enter="
          () => {
            passwordFocus = false
            onNext()
          }
        "
      />
    </van-form>
    <p v-if="verifkStep == 3" style="text-align: center; font-size: 0.24rem">
      {{ $t('verify.passwordtips') }}
    </p>
    <div style="height: 0.2rem"></div>
    <div
      v-if="!isLoading"
      :class="verifkStep == 2 && code.length < 6 ? 'btn_100 btn_grey' : 'btn_100 btn_yellow'"
      style="margin-top: 1rem"
      @click="onNext"
    >
      {{ verifkStep == 3 ? 'Reset' : $t('verify.next') }}
    </div>
    <div
      v-else
      class="btn_100 btn_yellow"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0.1rem 0 0.1rem 0;
      "
    >
      <img :src="`${resBaseUrl}loading.gif`" width="28" height="28" />
    </div>
    <div class="popup_footer" @click="onChat">
      {{ $t('register.service') }}
    </div>
  </div>
</template>

<script>
import InputField from '@/components/InputField.vue'
import { config } from '@/common/config'
import { validatePassword, validateUsername } from '@/common/valiadate.js'
import { mapActions, mapState } from 'pinia'
import { useUserStore } from '@/stores/user'
import { BUS } from '@/event/EventCenter'
import { REPORT_EVENT, reportGtag } from '@/common/mgtag'
// import { showFailToast } from 'vant'
export default {
  name: 'LobbyVerify',
  components: { InputField },
  props: {
    title: {
      type: String,
      default: 'Reset Password'
    },
    verify: {
      type: Function,
      default: () => console.error('verify must be not undefined !!!')
    },
    api: {
      type: Function,
      default: () => console.error('verify api must be not undefined !!!')
    },
    from: {
      type: String,
      default: ''
    },
    changeStep: {
      type: Function,
      default: () => console.log('changeStep')
    },
    verifkStep: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      isLoading: false,
      username: '',
      password: '',
      resBaseUrl: config.resBaseUrl,
      // step: 1,
      code: '',
      cd: 60,
      timer: null,
      userNameKey: 1,
      errMsg: '',
      passwordKey: 1,
      codeKey: 1,
      usernameFocus: true,
      passwordFocus: false
    }
  },
  watch: {
    verifkStep(newValue, oldValue) {
      if (newValue != oldValue) {
        this.isLoading = false
        if (newValue == 2) {
          this.password = ''
          this.passwordKey++
        } else if (newValue == 1) {
          this.code = ''
          this.codeKey++
        }
      }
    }
  },
  computed: {
    ...mapState(useUserStore, ['countries', 'country'])
  },
  unmounted() {
    this.isLoading = false
    this.username = ''
    this.password = ''
    this.resBaseUrl = config.resBaseUrl
    // this.step = 1
    this.code = ''
    this.cd = 60
    this.timer = null
  },
  mounted() {
    // this.step = 1
    this.changeStep(1)
    this.username = ''
    this.password = ''
    this.code = ''
    this.cd = 60
    !this.timer &&
      (this.timer = setInterval(() => {
        this.verifkStep == 2 && this.cd > 0 && this.cd--
      }, 1000))
  },

  methods: {
    ...mapActions(useUserStore, { checkBindViaUser: 'checkBindViaUser' }),
    validatePassword,
    validateUsername,
    check() {
      if (this.validateUsername(this.username).length > 0) {
        return false
      }

      return this.validatePassword(this.password).length <= 0
    },
    onTryAgain() {
      //发验证码
      this.verify(this.country, this.username).then((response) => {
        console.log(response)
        if (response) {
          document.querySelector('.code') && document.querySelector('.code').focus()
          this.cd = 60
        }
      })
    },
    onNext() {
      if (
        this.verifkStep == 1 &&
        (this.username == '' || this.validateUsername(this.username).length > 0)
      ) {
        this.$bus.$emit(BUS.CHECK_INPUT_VALUE, this.from)
        return
      }
      if (this.verifkStep == 1) {
        reportGtag(REPORT_EVENT.REGISTER.NEXT, 'click')
        this.isLoading = true
        this.checkBindViaUser(this.country, this.username).then((res) => {
          if (res.phoneNumber == '') {
            // showFailToast({
            //   message: this.$t('message.unexists'),
            //   wordBreak: 'break-word'
            // })
            this.$bus.$emit(BUS.CHANGE_IPUTfIELD_ERROR_TIPS, {
              inputType: 'reset_username',
              err: this.$t('message.unexists')
            })
            this.isLoading = false
          } else {
            this.changeStep(2)
            reportGtag(REPORT_EVENT.REGISTER.R2_COMPLETED, 'click')
            document.querySelector('.code') && document.querySelector('.code').focus()
            //发验证码
            this.verify(this.country, this.username)
              .then((response) => {
                console.log(response)
                if (response) {
                  document.querySelector('.code') && document.querySelector('.code').focus()
                  this.cd = 60
                }
              })
              .finally(() => {
                this.isLoading = false
              })
          }
        })
        reportGtag(REPORT_EVENT.REGISTER.R2_VERIFICATION_CODE, 'click')
      } else if (this.verifkStep == 2) {
        if (this.isLoading) {
          return
        }
        this.changeStep(3)
      } else if (this.verifkStep == 3) {
        if (this.isLoading || this.code.length < 6) {
          return
        }
        reportGtag(REPORT_EVENT.REGISTER.R2_NEXT, 'click')
        if (this.validatePassword(this.password).length > 0) {
          this.$bus.$emit(BUS.CHECK_INPUT_VALUE, this.from)
          return
        }
        this.isLoading = true
        this.api(this.country, this.password, this.username, this.code).catch((err) => {
          this.$bus.$emit(BUS.CHANGE_IPUTfIELD_ERROR_TIPS, {
            inputType: 'reset_password',
            err: err.message
          })
        })
      } else {
        // this.step++
        this.changeStep(4)
      }
    },
    onChangeCode() {
      console.log(this.code)
      if (this.code.length > 5) {
        this.onNext()
      }
    },
    onChat() {
      this.$bus.$emit(BUS.SHOW_CHAT)
      if (this.from == 'register') {
        reportGtag(REPORT_EVENT.REGISTER.CUSTOMER_SERVICE, 'click')
      }
    },
    onFocusUserName() {
      if (this.from == 'register') {
        reportGtag(REPORT_EVENT.REGISTER.R1_ACCOUNT_NUMBER, 'click')
      }
    },
    onFocusPassWord() {
      if (this.from == 'register') {
        reportGtag(REPORT_EVENT.REGISTER.R3_PASSWORD, 'click')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.popup {
  width: 90%;
  height: auto;
  border-radius: 12px;
  display: block;
  padding: 5% 5% 5% 5%;
  margin: 0 auto;

  h1 {
    font-size: 0.3rem;
    line-height: 0.4rem;
    margin: 0.1rem 0;
    font-weight: normal;
  }

  h2 {
    display: flex;
    flex-direction: column;
    font-size: 0.24rem;
    line-height: 0.3rem;
    margin: 0.1rem 0;
    font-weight: normal;
    color: #ffddac;
    font-size: 0.31rem;
    width: 100%;
    text-align: center;
  }

  p {
    line-height: 0.32rem;
    margin: 0;
    color: #fff;
  }

  .popup_nation {
    width: 100%;
    overflow: hidden;

    li {
      float: left;
      width: 93.4%;
      border-radius: 0.16rem;
      display: inline-block;
      line-height: 0.5rem;
      border: 2px solid #aa884a;
      padding: 3%;
      margin: 0.15rem 0;

      P {
        float: left;
        color: #aa884a;
        font-size: 0.24rem;
        margin-left: 0.2rem;
        line-height: 0.75rem;
        display: inline-block;
      }

      img {
        border-radius: 0.16rem;
        float: left;
        width: 25%;
      }

      i {
        float: right;
        font-size: 0.75rem;
        color: #ffddac;
        display: none;
      }
    }
  }

  .popup_nation_active {
    border: 2px solid #ffddac !important;
    box-shadow:
      inset 0 0 0.2rem #ffddac,
      inset 0 0 0.1rem #ffddac,
      inset 0 0 0.05rem #ffddac;

    p {
      color: #ffddac !important;
    }

    i {
      color: #ffddac !important;
      display: block !important;
    }
  }

  .steps {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0.8rem 0 0.3rem 0;

    .step {
      flex-basis: 50%;
    }

    .step-head {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }

    .step:last-of-type .step-head .line {
      display: none;
    }

    .active-icon {
      color: #fff !important;
      background-color: #aa884a !important;
    }

    .icon {
      font-size: 0.3rem;
      line-height: 0.6rem;
      font-weight: bold;
      color: #95a5a5;
      text-align: center;
      position: absolute;
      width: 0.6rem;
      height: 0.6rem;
      background-color: #324559;
      border-radius: 50%;
      z-index: 1;
    }

    .line {
      position: absolute;
      right: -50%;
      left: 50%;
      width: 100%;
      height: 0.1rem;
      background-color: #aa884a;
      z-index: 0;
    }

    .active-line {
      background-color: #324559 !important;
    }
  }

  .code_digit {
    margin: 0.2rem 0;
    padding: 0;
    width: 100%;
    overflow: hidden;

    li {
      line-height: 0.7rem;
      background-color: #ffddac;
      display: inline-block;
      border-radius: 0.16rem;
      float: left;
      width: 14%;
      height: 0.7rem;
      margin: 0 1.33%;
      padding: 0;
      text-align: center;
      color: black;
      font-size: 0.48rem;
    }

    input {
      outline-style: none;
      outline-width: 0;
      border: none;
      border-style: none;
      text-shadow: none;
      -webkit-appearance: none;
      -webkit-user-select: text;
      outline-color: transparent;
      background-color: transparent;
      box-shadow: none;
      font-size: 0.48rem;
      line-height: 0.7rem;
      float: left;
      width: 94.5%;
      margin: -0.7rem 0 0 5.5%;
      padding: 0;
      position: relative;
      z-index: 2;
      letter-spacing: 0.71rem;
      overflow: hidden;
      overflow-x: hidden;
      text-align: left;
      color: rgba($color: #000000, $alpha: 0);
    }
  }

  .btn_100 {
    line-height: 0.8rem;
    text-align: center;
    border-radius: 0.4rem;
    margin: 0.4rem 0;
    font-size: 0.33rem;
  }

  .btn_yellow {
    color: #fff;
    background-color: #aa884a;
    border: 2px solid #aa884a;
  }

  .btn_grey {
    color: #9b9b9b;
    background-color: #bbbebf;
    border: 2px solid #8d8d8d;
  }

  .popup_footer {
    text-align: center;
    margin: 0.3rem 0 0.3rem 0;
    // padding: 1.4rem 0 0;
    height: auto;
    width: 100%;
    color: #ffddac;
    font-size: 0.28rem;

    overflow: hidden;
    text-decoration: underline;
  }

  .error-message {
    margin-top: -0.3rem;
    margin-bottom: 0.3rem;
    font-weight: 400;
    font-size: 0.2rem;
    color: #e60012;
    line-height: 0.28rem;
    text-align: left;
    height: 0.2rem;
  }
}
</style>
